import React from 'react';
import img from "../../images/giphy.gif"
const Placed = (props) => {
    return (
        <div>
            <img src={img} alt="" />
        </div>
    );
};

export default Placed;